/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Streak_Freeze_AvailableInputs */

const en_us2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One free miss this quarter`)
};

const pt_br2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma falta livre neste trimestre`)
};

const es_419_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una falta libre este trimestre`)
};

const pt_pt2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma falta livre neste trimestre`)
};

const fr_fr2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un oubli autorisé ce trimestre`)
};

const de_de2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine freie Fehlwoche in diesem Quartal`)
};

const it_it2_streak_freeze_available = /** @type {(inputs: Streak_Freeze_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'assenza libera in questo trimestre`)
};

/**
* | output |
* | --- |
* | "One free miss this quarter" |
*
* @param {Streak_Freeze_AvailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const streak_freeze_available = /** @type {((inputs?: Streak_Freeze_AvailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Streak_Freeze_AvailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_streak_freeze_available(inputs)
	if (locale === "es-419") return es_419_streak_freeze_available(inputs)
	if (locale === "pt-PT") return pt_pt2_streak_freeze_available(inputs)
	if (locale === "fr-FR") return fr_fr2_streak_freeze_available(inputs)
	if (locale === "de-DE") return de_de2_streak_freeze_available(inputs)
	if (locale === "it-IT") return it_it2_streak_freeze_available(inputs)
	return en_us2_streak_freeze_available(inputs)
});
export { streak_freeze_available as "streak.freeze_available" }